@if (isLoaded && requisition) {
  <rt-requisitions-toolbar-container [requisition]="requisition" [assignments]="assignments" />
  <router-outlet />
  <rt-requisitions-drop-area-container
    [requisitionId]="requisition.id"
    [dragEventData]="dragEventData"
  />
} @else {
  <rt-spinner />
}
